/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializes average emissions per site.
 * @export
 * @interface SiteEmissionsAvg
 */
export interface SiteEmissionsAvg {
    /**
     * 
     * @type {number}
     * @memberof SiteEmissionsAvg
     */
    avgEmissions: number;
    /**
     * 
     * @type {string}
     * @memberof SiteEmissionsAvg
     */
    site: string;
    /**
     * 
     * @type {string}
     * @memberof SiteEmissionsAvg
     */
    siteName: string;
}

/**
 * Check if a given object implements the SiteEmissionsAvg interface.
 */
export function instanceOfSiteEmissionsAvg(value: object): value is SiteEmissionsAvg {
    if ((!('avgEmissions' in (value as Record<string, any>)) && !('avg_emissions' in (value as Record<string, any>))) || ((value as Record<string, any>)['avgEmissions'] === undefined && (value as Record<string, any>)['avg_emissions'] === undefined)) return false;
    if (!('site' in value) || value['site'] === undefined) return false;
    if ((!('siteName' in (value as Record<string, any>)) && !('site_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['siteName'] === undefined && (value as Record<string, any>)['site_name'] === undefined)) return false;
    return true;
}

export function SiteEmissionsAvgFromJSON(json: any): SiteEmissionsAvg {
    return SiteEmissionsAvgFromJSONTyped(json, false);
}

export function SiteEmissionsAvgFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteEmissionsAvg {
    if (json == null) {
        return json;
    }
    return {
        
        'avgEmissions': json['avg_emissions'],
        'site': json['site'],
        'siteName': json['site_name'],
    };
}

export function SiteEmissionsAvgToJSON(json: any): SiteEmissionsAvg {
    return SiteEmissionsAvgToJSONTyped(json, false);
}

export function SiteEmissionsAvgToJSONTyped(value?: SiteEmissionsAvg | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'avg_emissions': value['avgEmissions'],
        'site': value['site'],
        'site_name': value['siteName'],
    };
}

